var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgNestedSafes = function SvgNestedSafes(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 4C75.405 4 96 24.595 96 50C96 75.404 75.405 96 50 96C24.596 96 4 75.404 4 50C4 24.595 24.596 4 50 4Z",
    className: "illustration-background-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46L50 33.1429",
    stroke: "#A1A3A7",
    className: "illustration-light-stroke",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46L40.3265 46C36.2119 46 34.1545 46 32.5829 46.8297C31.2005 47.5596 30.0766 48.7242 29.3722 50.1566C28.5714 51.7851 28.5714 54.5936 28.5714 58.8571",
    stroke: "#A1A3A7",
    className: "illustration-light-stroke",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1429 67.4289C37.1429 72.1627 33.3053 76.0003 28.5714 76.0003C23.8376 76.0003 20 72.1627 20 67.4289C20 62.695 23.8376 58.8574 28.5714 58.8574C33.3053 58.8574 37.1429 62.695 37.1429 67.4289Z",
    stroke: "#A1A3A7",
    className: "illustration-light-stroke",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46L59.6735 46C63.7881 46 65.8455 46 67.4171 46.8297C68.7995 47.5596 69.9234 48.7242 70.6278 50.1566C71.4286 51.7851 71.4286 54.5936 71.4286 58.8571",
    stroke: "#A1A3A7",
    className: "illustration-light-stroke",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8571 67.4289C62.8571 72.1627 66.6947 76.0003 71.4286 76.0003C76.1624 76.0003 80 72.1627 80 67.4289C80 62.695 76.1624 58.8574 71.4286 58.8574C66.6947 58.8574 62.8571 62.695 62.8571 67.4289Z",
    stroke: "#A1A3A7",
    className: "illustration-light-stroke",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5714 24.5714C58.5714 29.3053 54.7339 33.1429 50 33.1429C45.2661 33.1429 41.4286 29.3053 41.4286 24.5714C41.4286 19.8376 45.2661 16 50 16C54.7339 16 58.5714 19.8376 58.5714 24.5714Z",
    stroke: "#A1A3A7",
    className: "illustration-light-stroke",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.204 9C78.2174 9 79.1098 9.6699 79.3913 10.647L79.4704 10.9201L79.7 11.6825L79.8863 12.256L79.9234 12.3643L80.072 12.7772L80.147 12.972L80.2227 13.1592L80.3773 13.5121C81.0512 14.9651 81.8869 15.6706 83.5658 16.3116L83.8241 16.4073L84.2521 16.5555L84.714 16.7046L85.2115 16.8564L85.7467 17.0129C86.7333 17.2888 87.407 18.1887 87.407 19.204C87.407 20.1629 86.8078 21.01 85.9203 21.3377L85.7607 21.3901L85.2238 21.5471L84.7247 21.6994L84.1509 21.886L83.6294 22.072C81.9265 22.7131 81.078 23.41 80.3998 24.8471L80.2993 25.0683L80.1468 25.4357L79.9973 25.8331L79.9231 26.0437L79.7745 26.4898L79.6241 26.9707L79.3908 27.7617C79.1098 28.7371 78.2174 29.407 77.204 29.407C76.1925 29.407 75.3075 28.7409 75.0168 27.7603L74.9376 27.4871L74.7078 26.7245L74.5585 26.2613L74.4101 25.8321C73.6977 23.8532 72.9482 22.9752 71.2052 22.2418L70.9721 22.1468L70.5746 21.9972L70.1451 21.8486L69.6816 21.6991L69.1823 21.5468L68.6453 21.3898C67.6717 21.1093 67 20.2193 67 19.204C67 18.1887 67.6737 17.2888 68.6464 17.0169L68.9197 16.9377L69.4375 16.7833L69.9185 16.6327L70.471 16.4467L70.5752 16.4096L70.9727 16.2599C72.6784 15.5863 73.4863 14.8223 74.1703 13.1919L74.2629 12.9641L74.4129 12.5654L74.5617 12.1346L74.6364 11.9066L74.7874 11.424L75.0216 10.6303C75.3075 9.66611 76.1925 9 77.204 9Z",
    className: "illustration-main-fill"
  })));
};
export default SvgNestedSafes;